import React from 'react';

const Chat = () => {
    return (
        <div>
            <h2>Message app</h2>
        </div>
    );
};

export default Chat;